var map = {
	"./base.js": 29,
	"./block.js": 291,
	"./event.js": 292,
	"./item.js": 293,
	"./itemimage.js": 86,
	"./screen.js": 133,
	"./sponsor.js": 295,
	"./stat.js": 296,
	"./template.js": 297
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;


//////////////////
// WEBPACK FOOTER
// ./src/store/serializers ^(.*\.(js$))[^.]*$/i
// module id = 290
// module chunks = 0